module.exports = "https://bin.bnbstatic.com/_next/static/images/Business Development-adcee731148e10feb38430dec131662a.svg";